import Service from "./service";

export default class extends Service {
  constructor() {
    super(...arguments);
    this.setEndPoint("product");
  }
}
